import styled, { css } from "styled-components";
import { breakpoints } from "@tvg/design-system";
import { ColorInjection } from "./types";
import { RaceCardContainer } from "../styled-components";

export const Container = styled(RaceCardContainer)<{
  isEmptyMessage?: boolean;
}>`
  display: grid;

  @media screen and ${breakpoints.tablet.max.sm} {
    margin-top: 0;
    border: 0;
    ${({ isEmptyMessage }) =>
      isEmptyMessage &&
      css`
        align-items: center;
        flex-grow: 1;
      `}
  }
`;

const commonStyle = css<ColorInjection>`
  box-shadow: ${({ colors }) => `inset 0px -1px 0px ${colors.blue["100"]}`};
  padding: 12px;
`;

export const TitleContainer = styled.div<ColorInjection>`
  ${commonStyle};
  height: 48px;
`;

export const SelectContainer = styled.div<ColorInjection>`
  ${commonStyle};
  height: 66px;
  background-color: ${({ colors }) => colors.blue_accent["000"]};
  display: flex;
  align-items: center;
`;

export const PoolTotal = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  text-align: right;
`;

export const PoolTotalInfo = styled.p<ColorInjection>`
  margin-bottom: 0;
  font-family: Roboto-regular, sans-serif;

  &:first-child {
    font-weight: 500;
    font-size: 14px;
    color: ${({ colors }) => colors.grey["900"]};
  }

  &:last-child {
    font-weight: 400;
    font-size: 12px;
    color: ${({ colors }) => colors.grey["800"]};
  }
`;

export const CornerCell = styled.div<ColorInjection>`
  width: 100%;
  height: 100%;
  position: relative;
  font-size: 12px;
  font-weight: 400;
  color: ${({ colors }) => colors.grey["800"]};
  font-family: Roboto-regular, sans-serif;

  &::before,
  &::after {
    position: absolute;
    height: 13px;
  }

  &::after {
    content: "1ST";
    top: calc(50% - 13px / 2 - 11.5px);
    width: 19px;
    left: 21px;
  }

  &::before {
    content: "2ND";
    width: 21px;
    left: 2px;
    top: calc(50% - 13px / 2 + 11.5px);
  }

  div {
    border: ${({ colors }) => `0.5px solid ${colors.blue["100"]}`};
    transform: rotate(45deg);
    position: absolute;
    left: -10px;
    width: 63.65px;
    top: 21px;
    border-radius: 16px;
  }
`;
